import React, { useEffect, useRef, useState } from "react"
import domParser from "../../utils/parser"

type Props = {
  html: string
}

const TableOfContents: React.FC<Props> = ({ html }) => {
  const parsedHtml = domParser(html)
  const ref = useRef<HTMLDivElement>(null)

  const [activeLink, setActiveLink] = useState<string | null>(null)

  let headings = null
  let tocOverrides = null
  try {
    const parsedHeadings = parsedHtml.querySelectorAll("h2") || []
    headings = Array.from(parsedHeadings)

    const tocOverridesJson = parsedHtml.getElementById("tocOverrides")
    if (tocOverridesJson) {
      tocOverrides = JSON.parse(tocOverridesJson.innerHTML)
    }
  } catch (error) {
    console.log(error)
  }

  useEffect(() => {
    if (!headings) return

    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && ref.current) {
          setActiveLink(entry.target.id)
        }
      })
    }

    const observer = new IntersectionObserver(observerCallback)

    headings.forEach(heading => {
      const ele = document.getElementById(heading.id) as HTMLHeadingElement
      observer.observe(ele)
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  if (!headings) return <></>

  return (
    <div className="mb-10" ref={ref}>
      <p>In This Article</p>
      <ul className="pl-6 border-l-2">
        {headings &&
          headings.map((heading, i) => {
            return (
              <li
                key={i}
                data-id={heading.id}
                className={`my-4 nav-link${activeLink == heading.id ? " active" : ""}`}
              >
                <a href={`#${heading.id}`} className="hover:opacity-70">
                  {(tocOverrides && tocOverrides[i + 1]) || heading.innerHTML}
                </a>
              </li>
            )
          })}
      </ul>
    </div>
  )
}

export default TableOfContents
